module.exports = __webpack_public_path__ + "img/head-mv2-05.b4b87fbd.jpg";